import { create } from 'zustand';
import { authAPI } from './api';

export const useAuthStore = create((set, get) => ({
  user: null,
  token: localStorage.getItem('pharmax_token') || null,
  loading: true,
  error: null,

  init: async () => {
    const token = localStorage.getItem('pharmax_token');
    if (!token) {
      set({ loading: false, user: null });
      return;
    }
    try {
      const res = await authAPI.getMe();
      set({ user: res.data.user, loading: false, token });
    } catch (err) {
      console.warn('Auth init failed:', err?.response?.status);
      // Only clear token on 401, not on network errors
      if (err?.response?.status === 401) {
        localStorage.removeItem('pharmax_token');
        set({ user: null, token: null, loading: false });
      } else {
        // Network error - keep token, try again
        set({ loading: false });
      }
    }
  },

  login: async (email, password) => {
    set({ error: null });
    try {
      const res = await authAPI.login({ email, password });
      const { token, user } = res.data;
      localStorage.setItem('pharmax_token', token);
      set({ user, token, error: null, loading: false });
      return true;
    } catch (err) {
      set({ error: err.response?.data?.detail || 'Login failed' });
      return false;
    }
  },

  signup: async (name, email, password) => {
    set({ error: null });
    try {
      const res = await authAPI.signup({ name, email, password });
      const { token, user } = res.data;
      localStorage.setItem('pharmax_token', token);
      set({ user, token, error: null, loading: false });
      return true;
    } catch (err) {
      set({ error: err.response?.data?.detail || 'Signup failed' });
      return false;
    }
  },

  logout: () => {
    localStorage.removeItem('pharmax_token');
    set({ user: null, token: null });
  },
}));
